import React, { useState } from "react";
import ModalLayout from "../..";
import Input from "../../../form/input";
import "./style.scss";
import { Radio } from "antd";

interface AcceptTicketProps {
  open: boolean;
  ticketData: any;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  description: string;
  requestedQty: string | number;
  approvedQty: string | number;
  onRequestedChange: (value: string) => void;
  onApprovedChange: (value: string) => void;
  isPaymentRequired: any;
  setIsPaymentRequired: (value: string) => void;
}

const AcceptTicket: React.FC<AcceptTicketProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  description,
  requestedQty,
  ticketData,
  approvedQty,
  onRequestedChange,
  setIsPaymentRequired,
  isPaymentRequired,
  onApprovedChange,
}) => {
  const showPaymentOption =
    ticketData?.service_id === 30007 ||
    ticketData?.service_id === 30011 ||
    ticketData?.service_id === 30009 ||
    ticketData?.service_id === 30013;
  return (
    <ModalLayout
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Accept Ticket"
      closeBtnText=""
      secondaryBtnText="CONFIRM"
      secButtonClass="ant-btn-secondary"
      layoutClassName="accept-ticket-modal"
    >
      <div className="p-4 accept">
        {/* Description */}
        <p className="text-[14px] text-[#333] mb-4">{description}</p>

        {showPaymentOption && (
          <Radio.Group
            onChange={(e) => setIsPaymentRequired(e.target.value)}
            value={isPaymentRequired}
            className="reason-radio-group flex flex-col gap-4"
          >
            <Radio value="with_payment" className="reason-option">
              Accept with payment
            </Radio>

            <Radio value="without_payment" className="reason-option">
              Accept without payment
            </Radio>
          </Radio.Group>
        )}

        <div className="input-wrapper flex flex-col">
          {/* Requested bin quantity */}
          <div className="mb-5 flex items-center gap-3">
            <label className="font-semibold mb-1 block">
              Requested bin quantity:
            </label>
            <div className="flex items-center gap-3">
              <Input
                isDisabled
                className="input-box"
                type="number"
                value={requestedQty}
                onChange={(e) => onRequestedChange(e.target.value)}
                inputClassname="w-[70px] text-center"
              />
              <span>pieces</span>
            </div>
          </div>

          {/* Approved bin quantity */}
          <div className="approved-bin-wrapper flex items-center gap-3">
            <label className="font-semibold mb-1 block">
              Approved bin quantity:
            </label>
            <div className="flex items-center gap-3 ">
              <Input
                className="input-box"
                type="number"
                value={approvedQty}
                onChange={(e) => onApprovedChange(e.target.value)}
                inputClassname="w-[70px] text-center"
              />
              <span>pieces</span>
            </div>
          </div>
        </div>
      </div>
    </ModalLayout>
  );
};

export default AcceptTicket;
